import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { License } from '@pixacare/domain';
import { FlattenedLicense } from '@pixacare/dtos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LicenseHttpService {
  private readonly http = inject(HttpClient);

  getLicenses(): Observable<FlattenedLicense[]> {
    return this.http.get<FlattenedLicense[]>(`${environment.apiBaseUrl}/License?flattened=true`);
  }

  answerInvitation(licenseId: number, accepted: boolean): Observable<License> {
    return this.http.patch<License>(
      `${environment.apiBaseUrl}/License/${licenseId}/AnswerInvitation?accepted=${accepted}`,
      null,
    );
  }

  removeLicense(licenseId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/License/${licenseId}`);
  }
}
